import { captureErrorInApm } from '../lib/apm/utils/captureErrorInApm.util';

const hasStringMessage = (value: object): value is { message: string } =>
  'message' in value && typeof (value as { message: unknown }).message === 'string';

const isStringArray = (value: unknown): value is string[] =>
  Array.isArray(value) && value.length > 0 && value.every((item) => typeof item === 'string');

export const normalizeSnackbarMessage = (message: unknown): string => {
  if (typeof message === 'string') {
    return message;
  }

  if (isStringArray(message)) {
    const joinedMessage = message.join('. ');

    try {
      captureErrorInApm.snackbarUntranslatedValidationError(
        new Error(
          `normalizeSnackbarMessage: validation message array received without a translatable code - ${joinedMessage}`,
        ),
      );
    } catch {
      /* ignore */
    }

    return joinedMessage;
  }

  if (message !== null && typeof message === 'object' && hasStringMessage(message)) {
    return message.message;
  }

  console.warn('normalizeSnackbarMessage: unexpected message type', typeof message);

  try {
    let serializedMessage: string;
    try {
      serializedMessage = JSON.stringify(message);
    } catch {
      serializedMessage = String(message);
    }

    captureErrorInApm.snackbarUnexpectedMessageError(
      new Error(
        `normalizeSnackbarMessage: unexpected message type "${typeof message}" - ${serializedMessage}`,
      ),
    );
  } catch {
    /* ignore */
  }

  return '';
};
